/**
 * /tenants/$slug/organizations — thin route shim (CIAM Slice 10).
 * Domain logic lives in features/organizations/.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  organizationsListSearchSchema,
  type OrganizationsListSearch,
} from "@/features/organizations/schemas";
import { fetchOrganizationsList } from "@/features/organizations/queries";
import { queryKeys } from "@/lib/query-keys";
import { OrganizationsListPage } from "@/features/organizations/pages/organizations-list-page";

export const Route = createFileRoute("/_authed/tenants/$slug/organizations/")({
  validateSearch: (raw: Record<string, unknown>): OrganizationsListSearch =>
    organizationsListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.organizations.list(context.tenant.id, deps.search),
      queryFn: () => fetchOrganizationsList(context.tenant.id, deps.search),
    }),
  component: OrganizationsListPage,
});
